<template>
  <div id="email-container">

    <div class="card-body">
      <ul class="nav nav-pills mb-0" id="pills-tab" role="tablist">
        <template v-for="(program, index) in programs">
          <li class="nav-item" @click="getDataEmailSettingForForm(program)">
            <a
              v-bind:class="{ active: index == 0 }"
               class="nav-link profile-tabs"
               id="general_detail_tab"
               data-toggle="pill"
               v-bind:href="'#detail_'+program.id">{{program.name}}</a>
          </li>
        </template>
      </ul>
    </div>


    <div class="tab-content detail-list" id="pills-tabContent">
      <template v-for="(program, index) in programs">
        <div class="tab-pane fade active" v-bind:class="{ show: index == 0 }" v-bind:id="'detail_'+program.id">

          <v-layout row wrap>
            <v-flex xs12 class="pd-right-25" style="margin: 0 25px;">
              <data-table model="App\Email" :program="program.id">
                <template v-slot:empty-head>
                  <v-icon size="72" :color="$store.getters.app.color_name">contacts</v-icon>
                </template>
                <template v-slot:empty-text>
                  <p class="subheading">Emails tmeplate will appear in this list </p>
                </template>
              </data-table>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 class="pd-right-25">
            <div style="margin:25px">
              <v-form
                      data-vv-scope="formModel"
                      :model="formModel"
                      @submit.prevent="submitForm('formModel')"
                      autocomplete="off"
                      method="post"
                      id="formModel"
                      accept-charset="UTF-8"
                      enctype="multipart/form-data"
              >

                <v-card-text :style="{ 'height': settings.dialog_height + 'px' || 'auto', 'padding': '10px', 'overflow-y': 'auto' }">
                  <v-tabs-items v-model="selectedTab" :touchless="true" class="mx-2" style="padding: 25px;">
                    <v-tab-item :value="tab_index" v-for="(tab, tab_index) in form.items" :key="tab_index" :eager="true">

                      <div v-if="tab.description" v-html="tab.description" class="subtitle-1 mb-3"></div>

                      <v-card v-if="Object.keys(form.items[tab_index].subs).length > 1" class="mb-3 elevation-1">
                        <v-tabs
                                v-if="Object.keys(form.items[tab_index].subs).length > 1"
                                v-model="selectedSubTab[tab_index]"
                                hide-slider
                                :color="app.color_name"
                                background-color="grey lighten-4"
                                show-arrows
                        >
                          <v-tab :key="'sub_tab_' + sub_index" :href="'#' + sub_index" v-for="(sub, sub_index) in tab.subs" style="weight: 600;">{{ sub.text }}</v-tab>
                        </v-tabs>
                      </v-card>

                      <v-tabs-items v-model="selectedSubTab[tab_index]" :touchless="true">
                        <v-tab-item :value="sub_index" v-for="(sub, sub_index) in tab.subs" :key="sub_index" :eager="true">
                          <div v-if="sub.description" v-html="sub.description" class="subtitle-1 mb-3"></div>
                          <div v-for="(form_item, form_index) in sub.items">

                            <div v-if="form_item.type == 'description'">
                              <v-sheet
                                      v-html="form_item.text"
                                      class="pa-3 mb-3 subtitle-1 elevation-1"
                                      color="grey lighten-4"
                              >
                              </v-sheet>
                            </div>

                            <div v-if="form_item.type == 'hidden'">
                              <input
                                      type="hidden"
                                      v-model="formModel[form_item.column]"
                              />
                            </div>

                            <div v-if="form_item.type == 'text' || form_item.type == 'email'">
                              <label class="label-field">
                                {{(form_item.required) ? translations.item + ' ' + form_item.text + $t('_required_') : form_item.text}}
                              </label>
                              <v-text-field
                                      solo
                                      denso
                                      :type="form_item.type"
                                      ___autofocus="form_index == 0 && uuid == null"
                                      v-model="formModel[form_item.column]"
                                      :ref="form_item.column"
                                      :data-vv-name="form_item.column"
                                      :data-vv-as="form_item.text.toLowerCase()"
                                      v-validate="form_item.validate"
                                      :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                                      :error-messages="errors.collect('formModel.' + form_item.column)"
                                      :prepend-inner-icon="form_item.icon"
                                      :placeholder="form_item.placeholder"
                                      :hint="form_item.hint"
                                      :persistent-hint="true"
                                      :prefix="form_item.prefix"
                                      :suffix="form_item.suffix"
                                      :readonly="form_item.readonly"
                                      class="form-control select-autocomplete tt"
                                      tabindex="1"
                              ></v-text-field>
                            </div>

                            <div v-if="form_item.type == 'wysiwyg'">
                              <span class="v-text-field">
                                <span class="v-label v-label--active theme--light">{{form_item.text}}</span>
                              </span>
                              <ckeditor
                                      :editor="ClassicEditor"
                                      v-model="formModel[form_item.column]"
                                      :ref="form_item.column"
                                      :data-vv-name="form_item.column"
                                      :data-vv-as="form_item.text.toLowerCase()"
                                      v-validate="form_item.validate"
                                      :error-messages="errors.collect('formModel.' + form_item.column)"
                                      :config="form_item.config"
                              >
                              </ckeditor><br />
                            </div>



                            <div v-if="form_item.type == 'color'">

                              <color-picker
                                      ___autofocus="form_index == 0 && uuid == null"
                                      v-model="formModel[form_item.column]"
                                      :color="formModel[form_item.column]"
                                      :mode="form_item.mode || 'hexa'"
                                      :ref="form_item.column"
                                      :data-vv-name="form_item.column"
                                      :data-vv-as="form_item.text.toLowerCase()"
                                      v-validate="form_item.validate"
                                      :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                                      :error-messages="errors.collect('formModel.' + form_item.column)"
                                      :prepend-inner-icon="form_item.icon"
                                      :placeholder="form_item.placeholder"
                                      :hint="form_item.hint"
                                      :persistent-hint="true"
                                      :prefix="form_item.prefix"
                                      :suffix="form_item.suffix"
                              >
                              </color-picker>

                            </div>


                            <div v-if="form_item.type == 'image' || form_item.type == 'avatar'">
                              <v-img :src="formModel[form_item.column + '_media_url']" class="mt-3 mb-1" :class="form_item.class" contain :style="{'width': form_item.image.thumb_width, 'height': form_item.image.thumb_height, 'max-width': form_item.image.thumb_max_width, 'max-height': form_item.image.thumb_max_height}" v-if="formModel[form_item.column + '_media_url']"></v-img>
                              <v-text-field
                                      @click="pickFile(form_item.column)"
                                      type="text"
                                      readonly
                                      v-model="formModel[form_item.column + '_media_name']"
                                      :ref="form_item.column"
                                      :data-vv-name="form_item.column"
                                      :data-vv-as="form_item.text.toLowerCase()"
                                      v-validate="form_item.validate"
                                      :label="(form_item.required) ? form_item.text + $t('_required_') : form_item.text"
                                      :error-messages="errors.collect('formModel.' + form_item.column)"
                                      :prepend-inner-icon="form_item.icon"
                                      :placeholder="form_item.placeholder"
                                      :hint="form_item.hint"
                                      :persistent-hint="true"
                                      :prefix="form_item.prefix"
                                      :suffix="form_item.suffix"
                              >
                                <template slot="append">
                                  <v-icon v-if="formModel[form_item.column + '_media_name'] != ''" @click="formModel[form_item.column + '_media_name'] = ''; formModel[form_item.column + '_media_url'] = ''; formModel[form_item.column + '_media_changed'] = true;">delete</v-icon>
                                </template>
                              </v-text-field>

                              <input
                                      type="file"
                                      style="display: none"
                                      :id="form_item.column"
                                      :name="form_item.column"
                                      accept="image/*"
                                      @change="onFilePicked"
                              >
                            </div>

                          </div>

                        </v-tab-item>
                      </v-tabs-items>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card-text>

                <v-divider v-if="settings.dialog_height" class="grey lighten-2"></v-divider>

                <v-card-actions v-if="!loadingForm">
                  <v-spacer></v-spacer>
                  <v-btn color="secondary" text :disabled="form.loading" large @click="$emit('data-list-events', {'closeDialog': true, 'reload': false})">
                    {{ $t('close') }}
                  </v-btn>
                  <v-btn
                          :color="app.color_name"
                          text _loading="form.loading"
                          :disabled="form.loading || remainingCount < 0"
                          large
                          type="submit"
                          class="ml-0">
                    {{ $t('save') }}
                  </v-btn>
                </v-card-actions>

              </v-form>
            </div>
            </v-flex>
          </v-layout>

        </div>
      </template>
    </div>

  </div>
</template>


  <script>
   //import '/ckeditor5/packages/ckeditor5-build-classic/build/ckeditor';

    export default {
      $_veeValidate: {
        validator: 'new'
      },
      data: () => {
        return {
          maxCount: 140,
          remainingCount: 140,
          formModel: {},
          loadingForm: true,
          loading: true,
          settings: [],
          programs: [],
          programID: Number,
          form: [],
          tabCount: 1,
          ClassicEditor: window.ClassicEditor,
          selectedTab: 'tab1',
          selectedSubTab: {
            tab1: 'sub1',
            tab2: 'sub1',
            tab3: 'sub1',
            tab4: 'sub1',
            tab5: 'sub1',
            tab6: 'sub1',
            tab7: 'sub1',
            tab8: 'sub1',
            tab9: 'sub1',
            tab10: 'sub1',
            tab11: 'sub1',
            tab12: 'sub1'
          },
          cacheParam: '{id}'
        }
      },
      watch: {
        form: function () {
          /*if (this.uuid) {
            const items = _.filter(_.concat(_.get(this.form.items, 'tab1.subs.sub1.items'), _.get(this.form.items, 'tab1.subs.sub2.items')), 'refresh');
            _.forEach(items, item => {
              this.check(item);
            });
          }*/
        }
      },
      props: {
        api: {
          default: '/app/data-form',
          required: false,
          type: String
        },
        programApi:
        {
          default: '/app/getprograms',
          required: false,
          type: String
        },
        emailUidFromApi: {
            default: '/app/getemailsetting',
            required: false,
            type: String
        },
        model: {
          default: 'App\\EmailSetting',
          required: false,
          type: String
        },
        uuid: {
          default: null,
          required: false,
          type: String
        },
        customer_id: {
          default: null,
          required: false,
          type: Number
        },
        program: {
          default: null,
          required: false,
          type: Number
        },
        item: {
          default: null,
          required: false,
          type: Object
        }
      },
      computed: {
        app () {
          return this.$store.getters.app
        },
      },
      created() {
        this.$validator.extend('nullable', {
          validate: (value, [testProp]) => { return true;  }
        });
        this.$validator.extend('unique', {
          validate: (value, [testProp]) => { return true;  }
        });
        this.$validator.extend('not_in', {
          validate: (value, [testProp]) => { return true;  }
        });

        moment.locale(this.$auth.user().locale);

      },
      beforeMount () {
        this.getProgramsByUser();
        // this.getUIDFromProgram();
      },
      methods: {
        pickFile (column) {
          this.activeFilePickerColumn = column
          document.getElementById(column).click();
        },
        getDataEmailSettingForForm(program){
            this.programID = program.id;
            this.getUIDFromProgram();
        },
        onFilePicked (e) {
          const files = e.target.files
          if(files[0] !== undefined) {
            this.formModel[this.activeFilePickerColumn + '_media_name'] = files[0].name
            if(this.formModel[this.activeFilePickerColumn + '_media_name'].lastIndexOf('.') <= 0) {
              return
            }
            const fr = new FileReader ()
            fr.readAsDataURL(files[0])
            fr.addEventListener('load', () => {
              this.formModel[this.activeFilePickerColumn + '_media_url'] = fr.result
              this.formModel[this.activeFilePickerColumn + '_media_file'] = files[0] // this is an image file that can be sent to server...
              this.formModel[this.activeFilePickerColumn + '_media_changed'] = true
            })
          } else {
            this.formModel[this.activeFilePickerColumn + '_media_name'] = ''
            this.formModel[this.activeFilePickerColumn + '_media_file'] = ''
            this.formModel[this.activeFilePickerColumn + '_media_url'] = ''
            this.formModel[this.activeFilePickerColumn + '_media_changed'] = true
          }
        },
        submitForm(scope) {
          this.form.has_error = false
          this.form.loading = true

          if (this.tabCount > 1) {
            for (let i = 2; i <= this.tabCount; i++) {

            }
          }

          this.$validator.validateAll(scope).then((valid) => {
            if (valid) {
              this.saveForm()
            } else {
              // Get first error and select tab where error occurs
              let field = this.errors.items[0].field
              let el = (typeof this.$refs[field] !== 'undefined') ? this.$refs[field] : null
              let subtab = (el !== null) ? el[0].$parent.$vnode.key : null
              let tab = (el !== null) ? el[0].$parent.$parent.$parent.$vnode.key : null

              if (tab !== null) this.selectedTab = tab
              if (tab !== null && subtab !== null) this.selectedSubTab[tab] = subtab

              this.form.loading = false

              return false
            }
          });
        },
        saveForm() {
          this.loading = true
          let that = this
          const model = this.model.split('\\')[2] || false;
          let settings = { headers: { 'content-type': 'multipart/form-data' } }
          // Remove image urls
          let formModel = Object.assign({}, this.formModel);

          if (this.programID){
              // formModel = Object.assign({'program_id': this.programID}, this.formModel);
            formModel['program_id'] = this.programID;
          }

          // Adding other fields which are not in the columns
          this.otherFormModel = document.querySelectorAll('[id^=otherFormModel-]');
          _.map(this.otherFormModel, itemItr => {
            if (itemItr.value==='skip') return;
            const key = itemItr.id.split('-')[1];
            if (key != 'main_currency') {
              formModel[key] = (itemItr.value == 'uuid' && key == 'customer_id') ? that.customer_id : itemItr.value;
            }
          });

          for (let field in this.formModel) {
            if (_.endsWith(field, '_media_url') || _.endsWith(field, '_media_name') || _.endsWith(field, '_media_file') || field == 'avatar') {
              formModel[field] = null;
            }
          }

          let formData = new FormData(document.getElementById('formModel'));
          formData.append('locale', this.$i18n.locale);
          formData.append('model', this.model);
          formData.append('formModel', JSON.stringify(formModel));
          formData.append('uuid', this.uuid);
          formData.append('program_id', this.programID);

          axios.post(this.api + '/save', formData, settings)
                  .then(res => {
                    if (res.data.status === 'success') {
                      let action = (this.uuid === null) ? 'item_created' : 'item_saved';
                      this.getUIDFromProgram();
                      this.$root.$snackbar(this.$t(action));
                      if (model==='Program') {
                        // this.$emit('data-list-events', {'closeDialog': true, 'reload': false});
                        this.$router.push({name: 'user.program'});
                        return;
                      }
                      this.$emit('data-list-events', {'closeDialog': true, 'reload': true})
                    }
                  })
                  .catch(err => {
                    if (typeof err.response !== 'undefined') {
                      if (typeof err.response.status !== 'undefined' && err.response.data.msg !== 'undefined') {
                        if (err.response.status == 422) {
                          this.$root.$snackbar(err.response.data.msg)
                          return
                        }
                      }
                      this.formModel.has_error = true
                      this.formModel.error = err.response.data.error
                      this.formModel.errors = err.response.data.errors || {}

                      // Get first error and select tab where error occurs
                      let field = Object.keys(this.formModel.errors)[0]
                      let el = (typeof this.$refs[field] !== 'undefined') ? this.$refs[field] : null
                      let tab = (el !== null) ? el[0].$parent.$vnode.key : null
                      if (tab !== null) this.selectedTab = tab

                      for (let field in this.formModel.errors) {
                        this.$validator.errors.add({
                          field: 'formModel.' + field,
                          msg: this.formModel.errors[field][0]
                        })
                      }
                    }
                  })
                  .finally(() => {
                    that.loading = false
                    that.form.loading = false

                  })
        },
        getDataFromApi (data = null) {
          this.loading = true
          let that = this;
          this.uuid = data ? (data.emailSetting && data.emailSetting.length > 0 ? (data.emailSetting[0].uuid ? data.emailSetting[0].uuid : null) : null) : null;
          return new Promise((resolve, reject) => {
            axios.get(this.api, {
              params: {
                locale: this.$i18n.locale,
                model: this.model,
                uuid: this.uuid
              }
            })
              .then(res => {
                if (res.data.status === 'success') {
                  let form = {}
                  form.items = res.data.form
                  form.loading = false
                  form.error = ''
                  form.errors = {}
                  form.has_error = false
                  form.success = false
                  that.loading = false
                  that.loadingForm = false
                  that.formModel = res.data.values;
                  resolve({
                    form
                  })
                }
              })
              .catch( err =>
                      console.log(err.response)
              )
              .finally(() => that.loading = false)
          })
        },
        getUIDFromProgram() {
            this.loading = true
            let that = this;
            return new Promise((resolve, reject) => {
                return axios.get(this.emailUidFromApi, {
                    params: {
                        programID: that.programID
                    }})
                    .then(res => {
                        this.getDataFromApi(res.data).then(data => {
                            that.form = data.form;
                            that.tabCount = Object.keys(that.form.items).length
                        });
                    })
                    .catch( err =>
                        console.log(err.response)
                    )
                    .finally(() => that.loading = false)
            })
        },
        getProgramsByUser () {
          this.loading = true
          let that = this;
          return new Promise((resolve, reject) => {
              axios.get(that.programApi)
              .then(res => {
                that.programs = res.data.programs;
                const default_program = that.programs[0];
                that.getDataEmailSettingForForm(default_program);
              })
              .catch( err =>
                console.log(err.response)
              )
              .finally(() => that.loading = false)
          })
        }
      }
    }
  </script>